import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { checkDangerousChars, deleteCookie, sanitize } from '@beef/utils';
import { getStore } from '@beef/redux';
import { instance } from "../../../components/Search/api/config";
import { prepareResult } from "../../../components/Search/utils/prepareResultData";
import { STEP } from "../../../components/Search/utils/constants";
import { addRecentlySearchedDebounce } from "../../../components/Search/utils/storage";
import { setCurrentModalStep, showMenuModal } from "../menu";
import { ECurrentModalStep } from "../../types";
import { CASH_SEARCH_COOKIE_NAME, EDIGI, methodsDigi } from "../../../../../utils/analytics";
import { selectHistoryContent, selectPureCorrection, selectQuery, selectRequestUrl } from "./selectors";
export var SEARCH_ACTION_TYPES = {
  SEARCH_SET_QUERY: 'setQuery',
  SEARCH_SET_STEP: 'setStep',
  SEARCH_TOGGLE_OPEN_SIDEBAR: 'toggleOpenSidebar',
  FETCH_ANY_QUERY: 'fetch_any_query',
  FETCH_WITH_TABS: 'fetch_with_tabs'
};
export var ActionSearch = {
  setQuery: createAction(SEARCH_ACTION_TYPES.SEARCH_SET_QUERY),
  setStep: createAction(SEARCH_ACTION_TYPES.SEARCH_SET_STEP),
  toggleOpenSidebar: createAction(SEARCH_ACTION_TYPES.SEARCH_TOGGLE_OPEN_SIDEBAR),
  fetchSearchData: createAsyncThunk(SEARCH_ACTION_TYPES.FETCH_ANY_QUERY, /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var query, _ref$withAnalytics, withAnalytics, dispatch, getState, rejectWithValue, state, url, searchUrl, _yield$instance$get, data, preparedData, err, step, _selectHistoryContent, cookieName, daysToExpire, valuesNumber;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, _ref$withAnalytics = _ref.withAnalytics, withAnalytics = _ref$withAnalytics === void 0 ? true : _ref$withAnalytics;
            dispatch = _ref2.dispatch, getState = _ref2.getState, rejectWithValue = _ref2.rejectWithValue;
            // Удаляем куку с историей переходов(кликов) по результатам поиска
            deleteCookie(CASH_SEARCH_COOKIE_NAME);
            state = getState();
            _context.prev = 4;
            url = selectRequestUrl(state);
            searchUrl = new URL(url);
            searchUrl.searchParams.set('st', query);
            _context.next = 10;
            return instance.get(searchUrl.toString());
          case 10:
            _yield$instance$get = _context.sent;
            data = _yield$instance$get.data;
            preparedData = prepareResult(data);
            if (withAnalytics) {
              methodsDigi.sendSearchEvent(_objectSpread(_objectSpread({}, preparedData), {}, {
                query: query
              }));
            }
            return _context.abrupt("return", preparedData);
          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](4);
            err = _context.t0;
            return _context.abrupt("return", rejectWithValue(err.response));
          case 21:
            _context.prev = 21;
            step = query ? STEP.result : STEP.recently;
            dispatch(ActionSearch.setStep(step));

            // Запись в куки истории запросов
            if (query && !checkDangerousChars(query)) {
              _selectHistoryContent = selectHistoryContent(state), cookieName = _selectHistoryContent.cookieName, daysToExpire = _selectHistoryContent.daysToExpire, valuesNumber = _selectHistoryContent.valuesNumber;
              addRecentlySearchedDebounce({
                query: query,
                cookieName: cookieName,
                daysToExpire: daysToExpire,
                valuesNumber: valuesNumber
              });
            }
            return _context.finish(21);
          case 26:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 17, 21, 26]]);
    }));
    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }()),
  fetchSearchDataWithTabs: createAsyncThunk(SEARCH_ACTION_TYPES.FETCH_WITH_TABS, /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query, _ref4) {
      var dispatch, getState, state, inputSearch, correction;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref4.dispatch, getState = _ref4.getState;
            state = getState();
            inputSearch = selectQuery(state);
            correction = selectPureCorrection(state);
            methodsDigi.sendClickEvent({
              query: inputSearch,
              correction: correction,
              item: query,
              type: EDIGI.tap
            });
            dispatch(ActionSearch.setQuery(query));
            _context2.next = 8;
            return dispatch(ActionSearch.fetchSearchData({
              query: query,
              withAnalytics: false
            }));
          case 8:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref5.apply(this, arguments);
    };
  }()),
  setQuerySearchParams: function setQuerySearchParams() {
    return function (dispatch) {
      if (typeof window !== 'undefined') {
        var url = new URL(window.location.href);
        var termInfo = url.searchParams.get('term');
        var termInfoString = termInfo && decodeURIComponent(sanitize(termInfo));
        if (termInfoString) {
          dispatch(ActionSearch.setQuery(termInfoString));
        }
      }
    };
  },
  showSearchModal: function showSearchModal() {
    return function (dispatch) {
      dispatch(setCurrentModalStep(ECurrentModalStep.search));
      dispatch(showMenuModal());
    };
  }
};
var toggleOpenSidebar = ActionSearch.toggleOpenSidebar;
export { toggleOpenSidebar };
export var setSearchQueryModule = function setSearchQueryModule() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _getStore = getStore('headerStore'),
    dispatch = _getStore.dispatch;
  dispatch(ActionSearch.setQuery(value));
};